module.exports = __webpack_public_path__ + "static/media/dashboard_sla.995ebd18.md";